/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    ClockCircleOutlined,
    CloseOutlined,
    DownloadOutlined,
} from '@ant-design/icons';
import { Drawer, Button, Dropdown } from 'antd';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../assets/Images/icons/icon-back';
import useQuery from '../../util/useQuery';
import RiskAssessmentDetail from './RiskAssessmentDetail';
import History from './RiskAssessmentHistory/HistoryDrawer';
import RiskAssessmentDetailView from './RiskAssessmentDetailView';
import RiskAssessmentService from '../../services/RiskAssessment.service';
import UserService from '../../services/UserService';
import ModalConfirm from '../../components/Shared/modal/confirm';
import ModalSuccess from '../../components/Shared/modal/success';
import ModalFail from '../../components/Shared/modal/fail';

import { ROUTER } from '../../constants/router';
import usePermission from '../../hooks/usePermission';

export const RiskAssessment = () => {
    const { view } = useParams();
    const { t } = useTranslation();
    let navigate = useNavigate();
    const params = useQuery();
    const [visible, setVisible] = useState(false);
    const [riskAssessmentData, setRiskAssessmentData] = useState();
    const [openConfirm, setOpenConfirm] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openFail, setOpenFail] = useState(false);
    const [isChangeStatus, setIsChangeStatus] = useState(true);

    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    const { isAuditor } = usePermission();

    const switchText = () => {
        const tab = params.get('tab');
        if (tab === '2') {
            return t('Risk Map');
        } else if (tab === '3') {
            return t('Likelihood');
        } else {
            return t('Type Risk Factor');
        }
    };

    const getRiskAssessmentHeader = async () => {
        try {
            const { data } =
                await RiskAssessmentService.getRiskAssessmentHeader();
            if (data?.resultData) {
                const item = data?.resultData[0];
                setRiskAssessmentData(item);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getRiskAssessmentHeader();
    }, []);

    const exportRiskAssessment = async (id, isPublic) => {
        try {
            const res = await RiskAssessmentService.exportRiskAssessment({
                publishVersion: isPublic,
            });
            const contentDisposition = res.headers['content-disposition'];
            console.log(
                contentDisposition ||
                    'Content-Disposition header not found in response.'
            );
            const objectURL = window.URL.createObjectURL(new Blob([res?.data]));
            const link = document.createElement('a');
            const filename =
                res.headers['content-disposition'].split('filename=')[1];
            link.href = objectURL;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            setOpenFail(true);
            console.log(error);
        }
    };

    const publicRiskAssessment = async (id) => {
        try {
            const { data } = await RiskAssessmentService.publicRiskAssessment({
                riskAssessmentId: id,
            });
            if (data?.resultMsg === 'FAILURE') {
                setOpenFail(true);
            } else {
                getRiskAssessmentHeader();
                setOpenSuccess(true);
            }
        } catch (error) {
            setOpenFail(true);
            console.log(error);
        }
    };

    const items = [
        {
            key: '1',
            type: 'group',
            label: t('RA.SelectExport'),
            children: [
                {
                    key: '1-1',
                    label: t('RA.LatestVersion'),
                    className: `p-4 ${
                        riskAssessmentData?.version.split('.')[0] === '0000'
                            ? 'hidden'
                            : ''
                    }`,
                    onClick: () => {
                        exportRiskAssessment(
                            riskAssessmentData?.riskAssessmentId,
                            true
                        );
                    },
                },
                {
                    key: '1-2',
                    label: t('RA.LatestModified'),
                    className: 'p-4',
                    onClick: () => {
                        exportRiskAssessment(
                            riskAssessmentData?.riskAssessmentId,
                            false
                        );
                    },
                },
            ],
        },
    ];

    return (
        <div>
            <div className="title flex">
                <button
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(`${ROUTER.RISK_MANAGEMENT.RA}`);
                    }}
                >
                    <IconBack />
                </button>
                {t('Risk Assessment')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.RiskManagement')} /
                </span>
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('Risk Assessment List')} /{' '}
                </span>
                <span> {switchText()}</span>
            </div>
            <div className="bg-white rounded-xl p-4 flex items-center space-x-2 my-4 justify-between">
                <div className="flex justify-center items-center space-x-4">
                    <span className="text-purple font-semibold text-2xl">
                        {t('RA.OrganizationRiskReport')}
                    </span>
                    <span className="text-xs">
                        {t('Version')} :{' '}
                        {riskAssessmentData?.version || '0000.0'}
                    </span>
                    <Button
                        icon={<ClockCircleOutlined />}
                        disabled={isAuditor}
                        onClick={(e) => {
                            setVisible(true);
                            setIsChangeStatus(true);
                        }}
                        className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm"
                    ></Button>
                    <Drawer
                        width={460}
                        title={
                            <div className="flex justify-between items-center">
                                <span className="text-purple text-[17px]">
                                    {t('History')}
                                </span>
                                <button
                                    onClick={(e) => setVisible(false)}
                                    className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                                >
                                    <CloseOutlined />
                                </button>
                            </div>
                        }
                        placement="right"
                        onClose={() => setVisible(false)}
                        closable={false}
                        open={visible}
                        className="history"
                    >
                        <History
                            setIsChangeStatus={setIsChangeStatus}
                            isChangeStatus={isChangeStatus}
                        />
                    </Drawer>
                </div>
                <div className={`${view && admin ? '' : 'hidden'}`}>
                    <div className="flex justify-center items-center space-x-4">
                        <Dropdown
                            trigger={['click']}
                            overlayStyle={{ width: '255px' }}
                            menu={{ items }}
                            placement="bottomRight"
                            disabled={isAuditor}
                        >
                            <Button
                                icon={<DownloadOutlined />}
                                type="primary"
                                size="large"
                                ghost
                            >
                                {t('Export')}
                            </Button>
                        </Dropdown>
                        <Button
                            disabled={isAuditor}
                            className={`${
                                riskAssessmentData?.version.split('.')[1] ===
                                    undefined ||
                                riskAssessmentData?.version.split('.')[1] ===
                                    '0'
                                    ? 'hidden'
                                    : ''
                            }`}
                            onClick={() => {
                                setOpenConfirm(true);
                            }}
                            size="large"
                            type="primary"
                        >
                            {t('common.publish')}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="bg-white rounded-xl p-4">
                {view === 'view' ? (
                    <RiskAssessmentDetailView
                        getRiskAssessmentHeader={() =>
                            getRiskAssessmentHeader()
                        }
                    />
                ) : (
                    <RiskAssessmentDetail />
                )}
            </div>
            <ModalConfirm
                open={openConfirm}
                handelOk={() => {
                    setOpenConfirm(false);
                    publicRiskAssessment(riskAssessmentData?.riskAssessmentId);
                }}
                handelClose={() => setOpenConfirm(false)}
                text={t('Do you want to confirm')}
            />
            <ModalSuccess
                open={openSuccess}
                handelClose={() => {
                    setOpenSuccess(false);
                }}
                handelOk={() => {
                    setOpenSuccess(false);
                }}
                text={t('Successfully submitted data')}
            />
            <ModalFail
                open={openFail}
                handelClose={() => {
                    setOpenFail(false);
                }}
                handelOk={() => {
                    setOpenFail(false);
                }}
                text={t('Failed to submit data')}
            />
        </div>
    );
};

export { default as RiskAssessmentList } from './RiskAssessmentList';
